import Axios from 'axios';
import Qs from 'qs';

export default {

  // 投诉分页列表
  listPage(
    community_id,
    type,
    username,
    content,
    page,
    per_page
  ) {
    return Axios.get('/llhd/complaints', {
      params: {
        community_id,
        type,
        username,
        content,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },
  
  // 投诉类型
  type() {
    return Axios.get('/llhd/complaint/types');
  }

}